<main class="container">
  @if (!isLoading) {
    <!-- product details data -->
    <section class="products-details">
      <!-- product bread crumbs section -->
      <div class="products-details__options">
        <!-- bread crumbs section -->
        <pwj-breadcrumbs [breadcrumbsData]="breadcrumbsData"></pwj-breadcrumbs>
        <!-- options menu -->
        <pwj-options-menu
          [menuOptions]="menuOptions"
          [isRowMode]="true"></pwj-options-menu>
      </div>
      <!-- product preview section-->
      <pwj-product-preview
        [previewData]="productPreviewData"></pwj-product-preview>
      <!-- product tags section -->
      @if (productTags && productTags.length > 0) {
        <div>
          <pwj-product-tags [tagsData]="productTags"></pwj-product-tags>
        </div>
      }
      <!-- product navigation tabs section -->
      @if ((navigationTabsData?.length || 0) > 0) {
        <div>
          <pwj-product-navigation-tabs
            [tabsData]="navigationTabsData"></pwj-product-navigation-tabs>
        </div>
      }

      <!-- product description section-->
      @if (((productDescription | translateData)?.length || 0) > 140) {
        <div>
          <pwj-product-description
            [productDescription]="productDescription"></pwj-product-description>
        </div>
      }
      <!-- product video -section -->
      @if (productVideo?.video) {
        <div>
          <pwj-product-video [productVideo]="productVideo"></pwj-product-video>
        </div>
      }
      <!-- product climatic properties section-->
      <pwj-product-climatic-properties
        [climaticData]="climaticData"></pwj-product-climatic-properties>
      <!-- product additional properties section-->
      <pwj-product-additional-properties
        [additionalProperties]="
          additionalSpecificationData
        "></pwj-product-additional-properties>
      <!-- product usage section-->
      @if (usageData && usageData.length > 0) {
        <div>
          <pwj-product-usage [usageData]="usageData"></pwj-product-usage>
        </div>
      }
      <!-- product expert section-->
      @if (
        expertOpinionsData?.specialist_note ||
        (expertOpinionsData?.specialist_photos?.length || 0) > 0 ||
        (expertOpinionsData?.specialist_video?.length || 0) > 0
      ) {
        <div>
          <pwj-product-expert-opinions
            [expertOpinionsData]="
              expertOpinionsData
            "></pwj-product-expert-opinions>
        </div>
      }
      <!-- faq section -->
      @if (faqData && faqData.length > 0) {
        <div>
          <pwj-faq-section
            [verticalMargin]="false"
            [faqData]="faqData"></pwj-faq-section>
        </div>
      }
      <!-- comment form box section -->
      <pwj-comment-form-box
        [pageId]="productId"
        pageName="product_id"></pwj-comment-form-box>
      <!-- product comments section -->
      <pwj-product-comments></pwj-product-comments>
    </section>
  } @else {
    <!-- skeleton loading -->
    <div>
      <pwj-product-details-skeleton></pwj-product-details-skeleton>
    </div>
  }
</main>
